// extracted by mini-css-extract-plugin
export default {"content":"TermsAndConditions_content__7jFsw","contentValue":"TermsAndConditions_contentValue__ohN0E"};